import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import ISummaryPanelProps from './CalculatorSummaryPanel.properties';
import styles from './CalculatorSummaryPanel.styles';

const PaperElevation = 2;
const paperElevation = PaperElevation;

class SummaryPanel extends React.PureComponent<ISummaryPanelProps> {

  render(): React.ReactNode {
    const { classes, data } = this.props;

    return (
      <div>
        <Paper elevation={paperElevation} className={classes.subPanel} square={true}>
          <p className={classes.subPanelTitle}>Results</p>
          <Table className={classes.summaryTable} >
            <TableBody>
              <TableRow key={'Available'} className={classes.summaryRow}>
                <TableCell className={classes.headingCell}>{data?.title}</TableCell>
                <TableCell
                  className={`${classes.dataCell} ${classes.textRightAlign}`}>
                  {data?.PriceDisplay}
                </TableCell>

              </TableRow>
            </TableBody>
          </Table>
        </Paper>

      </div>
    );
  }
}

export default withStyles(styles, { index: 1 })(SummaryPanel);
